export enum SubscriptionTypes {
  trial = 'Trial', // It is still necessary
  recurly = 'Recurly',
  offline = 'Off-line',
}
